// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Classes */\n.side-menu-item {\n    padding-top: 18px;\n    padding-bottom: 18px;\n    border-bottom: 1px solid #dfe2e6;\n    cursor: pointer;\n}\n\n.side-menu-item:hover {\n    background-color: #dfe2e6;\n}\n\n.side-menu-item-container {\n    margin-left: 50px;\n    margin-right: 50px;\n}\n\n.side-menu-item-img {\n    width: 1.5rem;\n}\n\n.side-menu-item-text {\n    display: inline-block;\n    vertical-align: middle;\n    margin-left: 8px;\n    font-size: 1rem;\n}", ""]);
// Exports
module.exports = exports;
